module.exports = __webpack_public_path__ + "img/mainmenbuttonCOL.23e48736.png";